import { useIsNodeDiagonalResizeEnabled } from './useIsNodeDiagonalResizeEnabled';

export const useResizeFillClassName = (applies = true): string | undefined => {
  const isEnabled = useIsNodeDiagonalResizeEnabled();
  return isEnabled && applies ? 'node-fill' : undefined;
};

export const useResizeFillAutoClassName = (): string | undefined => {
  const isEnabled = useIsNodeDiagonalResizeEnabled();
  return isEnabled ? 'node-fill-auto' : undefined;
};

export const useResizeRowSpreadClassName = (): string | undefined => {
  const isEnabled = useIsNodeDiagonalResizeEnabled();
  return isEnabled ? 'node-row-spread' : undefined;
};

export const useResizeMediaFillClassName = (hasIntrinsicDimensions: boolean): string | undefined => {
  const isEnabled = useIsNodeDiagonalResizeEnabled();
  if (!isEnabled) return undefined;
  return hasIntrinsicDimensions ? 'node-fill' : 'node-fill-media';
};

export const useResizeScalerAttributes = (applies = true): { 'data-node-resize-scaler'?: true } => {
  const isEnabled = useIsNodeDiagonalResizeEnabled();
  return isEnabled && applies ? { 'data-node-resize-scaler': true } : {};
};
